/**
 * Popup kupon di halaman checkout - markup & endpoint-nya di
 * includes/woocommerce/checkout-coupons.php.
 *
 * Alur pasang/lepas kupon sengaja dipecah dua langkah:
 *
 * 1. Endpoint theme (wc-ajax dufeng_checkout_apply_coupon /
 *    dufeng_checkout_remove_coupon) cuma mengubah keranjang dan mengembalikan
 *    pesan hasilnya.
 * 2. Halaman di-refresh lewat trigger `update_checkout` bawaan WooCommerce,
 *    jadi ongkir, biaya, baris diskon, DAN isi popup (bar pemicu + daftar
 *    kupon, dikirim sebagai fragment) dihitung ulang oleh WooCommerce sendiri -
 *    bukan ditebak di sini.
 *
 * Popup dibiarkan terbuka setelah kupon berhasil dipasang: kuponnya tetap
 * tampil di daftar, pindah ke bagian "Applied Coupons" lengkap dengan tombol
 * [Remove]. Menutup popup urusan user.
 *
 * Semua kalimat datang dari PHP lewat dufeng_checkout_coupon_params.i18n
 * supaya ikut terjemahan yang sama dengan yang dirender server.
 */

var MODAL_ID = "dufeng-coupon-modal";
var BODY_OPEN_CLASS = "dufeng-coupon-modal-open";
var NOTICE_TIMEOUT = 6000;

function getParams() {
  return window.dufeng_checkout_coupon_params || null;
}

function getText(key) {
  var params = getParams();
  return (params && params.i18n && params.i18n[key]) || "";
}

function getModal() {
  return document.getElementById(MODAL_ID);
}

function showNotice(modal, message, isError) {
  var notice = modal.querySelector(".dufeng-coupon-modal__notice");
  if (!notice) return;

  clearTimeout(notice.dufengTimer);

  if (!message) {
    notice.hidden = true;
    notice.textContent = "";
    return;
  }

  notice.textContent = message;
  notice.classList.toggle("is-error", !!isError);
  notice.hidden = false;

  notice.dufengTimer = setTimeout(function () {
    notice.hidden = true;
    notice.textContent = "";
  }, NOTICE_TIMEOUT);
}

function setBusy(modal, busy) {
  modal.classList.toggle("is-busy", busy);
}

/**
 * Samakan teks semua pemicu popup dengan bar di atas tabel review order.
 *
 * Bar itu satu-satunya pemicu yang dirender server DAN ikut cart fragments,
 * jadi dialah sumber kebenaran status kupon ("Apply coupon" vs "Coupon: KODE").
 * Tombol di sidebar — yang disuntik checkout-summary.js — cukup menyalin, tidak
 * perlu menghitung ulang kupon mana yang aktif sendiri.
 */
function syncTriggers() {
  var bar = document.querySelector(".dufeng-coupon-bar");
  var source = bar && bar.querySelector(".dufeng-coupon-bar__label");
  if (!source) return;

  var label = source.textContent;
  var hasCoupon = bar.classList.contains("has-coupon");
  var targets = document.querySelectorAll("[data-dufeng-coupon-sync]");

  for (var i = 0; i < targets.length; i++) {
    targets[i].textContent = label;
    targets[i].classList.toggle("has-coupon", hasCoupon);
  }
}

/**
 * Pasang / lepas kupon, lalu minta WooCommerce menghitung ulang halaman.
 *
 * Kegagalan jaringan tetap diakhiri dengan `update_checkout`: keranjang di
 * server bisa saja sudah berubah, jadi lebih baik menampilkan angka yang
 * benar-benar dari server daripada membiarkan tampilan lama.
 */
function sendCoupon(modal, url, code) {
  var params = getParams();
  if (!params || !url) return;

  var $ = window.jQuery;

  setBusy(modal, true);
  showNotice(modal, "");

  var body = new URLSearchParams();
  body.append("coupon", code);
  body.append("security", params.nonce);

  fetch(url, {
    method: "POST",
    credentials: "same-origin",
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    body: body.toString(),
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (data) {
      showNotice(modal, data && data.message ? data.message : "", !(data && data.success));

      if (data && data.success) {
        var input = modal.querySelector(".dufeng-coupon-form__input");
        if (input) input.value = "";
      }

      if ($) $(document.body).trigger("update_checkout");
    })
    .catch(function () {
      showNotice(modal, getText("request_failed"), true);
      if ($) $(document.body).trigger("update_checkout");
    })
    .then(function () {
      setBusy(modal, false);
    });
}

function openModal(modal) {
  if (!modal.hidden) return;

  modal.hidden = false;
  modal.setAttribute("aria-hidden", "false");
  document.body.classList.add("no-scroll", BODY_OPEN_CLASS);

  var input = modal.querySelector(".dufeng-coupon-form__input");
  if (input) input.focus();
}

function closeModal(modal) {
  if (modal.hidden) return;

  modal.hidden = true;
  modal.setAttribute("aria-hidden", "true");
  document.body.classList.remove("no-scroll", BODY_OPEN_CLASS);
  showNotice(modal, "");
}

export function initCheckoutCoupon() {
  var modal = getModal();
  if (!modal) return;

  var params = getParams();

  // Pemicunya ada dua dan salah satunya (tombol di sidebar ringkasan) disuntik
  // checkout-summary.js SETELAH modul ini jalan, plus dipasang ulang tiap kali
  // isi keranjang dirender ulang - jadi listener-nya didelegasikan ke document,
  // bukan di-bind ke tombolnya.
  document.addEventListener("click", function (event) {
    var trigger = event.target.closest("[data-dufeng-coupon-open]");
    if (!trigger) return;

    event.preventDefault();
    openModal(modal);
  });

  modal.addEventListener("click", function (event) {
    if (event.target.closest("[data-dufeng-coupon-close]")) {
      event.preventDefault();
      closeModal(modal);
      return;
    }

    var apply = event.target.closest("[data-dufeng-coupon-apply]");
    if (apply) {
      event.preventDefault();
      sendCoupon(modal, params && params.apply_url, apply.getAttribute("data-dufeng-coupon-apply"));
      return;
    }

    var remove = event.target.closest("[data-dufeng-coupon-remove]");
    if (remove) {
      event.preventDefault();
      sendCoupon(modal, params && params.remove_url, remove.getAttribute("data-dufeng-coupon-remove"));
      return;
    }

    if (event.target.closest("[data-dufeng-coupon-submit]")) {
      event.preventDefault();
      var input = modal.querySelector(".dufeng-coupon-form__input");
      var code = input ? input.value.trim() : "";

      if (!code) {
        showNotice(modal, getText("please_enter"), true);
        if (input) input.focus();
        return;
      }

      sendCoupon(modal, params && params.apply_url, code);
    }
  });

  // Popup-nya dicetak di wp_footer, di luar <form class="checkout">, dan input
  // kupon sengaja tidak dibungkus <form> sendiri - jadi Enter di sana tidak
  // punya perilaku bawaan sama sekali dan harus diarahkan manual ke tombolnya.
  modal.addEventListener("keydown", function (event) {
    if ("Enter" !== event.key) return;
    if (!event.target.closest(".dufeng-coupon-form__input")) return;

    event.preventDefault();
    var submit = modal.querySelector("[data-dufeng-coupon-submit]");
    if (submit) submit.click();
  });

  document.addEventListener("keydown", function (event) {
    if ("Escape" === event.key) closeModal(modal);
  });

  syncTriggers();

  // updated_checkout di-trigger WooCommerce lewat jQuery (setelah fragment bar
  // & daftar kupon dipasang), updated_wc_div saat isi keranjang di sidebar
  // dirender ulang - keduanya bisa memunculkan tombol pemicu yang teksnya
  // masih default.
  var $ = window.jQuery;
  if ($) {
    $(document.body).on("updated_checkout updated_wc_div", syncTriggers);
  }
}
